<template>
  <v-container
    v-show="loaded"
    class="pt-16"
  >
    <v-card
      class="mx-auto"
      max-width="800"
      flat
      tile
    >
      <v-card-title>
        <h1
          class="fs-28 text-wrap"
          tabindex="0"
        >
          {{ $bct('Which child would you like to create an application for?') }}
        </h1>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-radio-group
              v-model="selectedChild"
              class="mb-5"
              hide-details
            >
              <RadioButton
                v-for="(child, index) in children"
                :key="child.id"
                :gap="radioButtonGap(index)"
                :subtitle="child.dob"
                :title="fullName(child)"
                :value="child"
                subtitle-icon="cake"
              />
            </v-radio-group>

            <v-btn
              @click="router.push({ name: 'ChildNew' })"
              color="primary"
              prepend-icon="add"
            >
              {{ $bct('Add another child') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :to="{ name: 'Dashboard' }"
          variant="text"
        >
          {{ $bct('Cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn
          @click="router.push({ name: 'ChildApply', params: { childId: selectedChild.id } })"
          :disabled="!selectedChild"
          color="primary"
        >
          {{ $bct('Continue') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import { capitalize } from '@/plugins/filters';
import RadioButton from '@/shared/components/form/RadioButton.vue';
import useApi from '@/shared/composables/useApi';

const { api } = useApi();
const route = useRoute();
const router = useRouter();
const store = useStore();
const $bct = inject('translator');

const children = ref([]);
const loaded = ref(false);
const selectedChild = ref(null);

function fullName(child) {
  let result = capitalize(child.first_name);
  if (child.middle_name) result += ` ${capitalize(child.middle_name)}`;
  result += ` ${capitalize(child.last_name)}`;

  return result;
}

async function load() {
  await loadChildren();
  loaded.value = true;
}

async function loadChildren() {
  if (!store.state.profile?.group_id) return;

  const resp = await api.parent.children.index(store.state.profile.group_id);
  children.value = resp.data;
}

function radioButtonGap(index) {
  return index === 0 ? null : 5;
}

onMounted(() => {
  store.dispatch('identify', {
    api,
    async success() {
      if (store.state.is_anonymous) {
        await router.replace({
          name: 'Signup',
          query: { redirect_url: route.fullPath },
        });
        return;
      }
      await load();
    },
    async failure() {
      await router.replace({
        name: 'Signup',
        query: { mode: 'login', redirect_url: route.fullPath },
      });
    },
  });
});
</script>
